import { formatDateRangeDuration } from "@src/appV2/redesign/utils/formatDateRangeDuration";
import { isBefore, isSameSecond } from "date-fns";

import { getOvertimeInfo } from "./getOvertimeInfo";
import { getShiftProgressAndWorkedTime } from "./getShiftProgressAndWorkedTime";

export function getShiftProgress(params: {
  clockInDate: Date;
  shiftStartDate: Date;
  shiftEndDate: Date;
  now: Date;
}) {
  const { clockInDate, shiftStartDate, shiftEndDate, now } = params;
  const defaultValues = {
    progress: 0,
    secondaryProgress: 0,
    timeWorked: "0s",
    timeLeft: "0h 00m left",
    isOvertime: false,
    overtimeText: "",
    totalTimeWorked: "",
  };

  const isShiftInProgress = isBefore(now, shiftEndDate) || isSameSecond(now, shiftEndDate);

  if (isShiftInProgress) {
    const { progress, timeWorked } = getShiftProgressAndWorkedTime({
      clockInDate,
      shiftStartDate,
      shiftEndDate,
      now,
    });

    return {
      ...defaultValues,
      progress,
      timeWorked,
      timeLeft: `${formatDateRangeDuration({
        startDate: now,
        endDate: shiftEndDate,
        format: "abbreviated",
        alwaysDisplayHours: false,
      })} left`,
    };
  }

  const { progress, secondaryProgress, overtimeText, totalTimeWorked } = getOvertimeInfo({
    clockInDate,
    shiftEndDate,
    now,
  });

  return {
    ...defaultValues,
    progress,
    secondaryProgress,
    overtimeText,
    totalTimeWorked,
    isOvertime: true,
  };
}
